import { CircleAIAppShell } from "@circle-react-uikit/CircleAIAppShell";
import {
  CIRCLE_V4_DESKTOP_SHELL_FLAG,
  DesktopShellEngineProvider,
} from "@circle-react-uikit/CircleAIAppShell/Layout/desktopShellEngineContext";
import { useIsFeatureFlagEnabled } from "@circle-react/hooks/UseCommunitySetting";
import type { ReactNode } from "react";

import { useCircleAIShellLayoutState } from "./useCircleAIShellLayoutState";

export const StoreConnectedShellLayout = ({
  children,
}: Readonly<{ children: ReactNode }>) => {
  const shellLayoutState = useCircleAIShellLayoutState();
  const isCompassDesktopShellEnabled = useIsFeatureFlagEnabled(
    CIRCLE_V4_DESKTOP_SHELL_FLAG,
  );

  return (
    <DesktopShellEngineProvider
      engine={isCompassDesktopShellEnabled ? "compass" : "circle"}
    >
      <CircleAIAppShell.Layout {...shellLayoutState}>
        {children}
      </CircleAIAppShell.Layout>
    </DesktopShellEngineProvider>
  );
};
